import React, { useMemo } from 'react';
import Slider from 'react-slick';

import { TestimonialContainer, TestimonialSubText, SliderOuterWrap, TestimonialTextWrap } from './TestimonialStyles';
import { OrangeBorder, PartnerIcons } from '../../Styles';
import { Heading, SubTitle, FlexDiv, GenericDiv } from 'commonStyles';
import { testimonialData } from '../../config';
import { SliderArrowNext, SliderArrowPrev } from 'common/SliderArrows/SliderArrows';

const Testimonial = ({ isMobile }) => {
	const settings = useMemo(() => ({
		arrows: true,
		swipeToSlide: true,
		speed: 500,
		slidesToShow: 2.4,
		slidesToScroll: 1,
		infinite: false,
		nextArrow: <SliderArrowNext isMobile={isMobile} customClass='bottomAlign' />,
		prevArrow: <SliderArrowPrev isMobile={isMobile} customClass='bottomAlign' />,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	}), [isMobile]);

	return (
		<TestimonialContainer>
			<OrangeBorder />
			<Heading fontSize={`${isMobile ? '28px' : '40px'}`} marBt='10px'>
				Customer Speaks
			</Heading>
			<TestimonialSubText>
				Read on to know what our esteemed customers have to say about our
				services.
			</TestimonialSubText>
			<SliderOuterWrap>
				<Slider {...settings}>
					{testimonialData.map((data, index) => {
						const { userName, desp, userCompany, logo, marginB } = data;
						return (
							<div key={userCompany}>
								<FlexDiv
									direction='column'
									height={`${!isMobile ? '280px' : '405px'}`}
									directionInMobile='column'
									justify='space-between'>
									<FlexDiv
										directionInMobile='column'
										direction='column'
										justify='flex-start'>
										<GenericDiv bottom_M={marginB ? marginB : '20'}>
											<PartnerIcons icon={logo} />
										</GenericDiv>
										<TestimonialTextWrap>{desp}</TestimonialTextWrap>
									</FlexDiv>
									<FlexDiv
										directionInMobile='column'
										justify='flex-end'
										direction='column'>
										<SubTitle
											bottom_M='4'
											color='#3b385e'
											fSize={`${isMobile ? '18px' : '24px'}`}>
											{userName}
										</SubTitle>
										<p className='font12'>{userCompany}</p>
									</FlexDiv>
								</FlexDiv>
							</div>
						);
					})}
				</Slider>
			</SliderOuterWrap>
		</TestimonialContainer>
	);
};

export default Testimonial;
